import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

export const StyledPreferencesHeader = styled.header`
  width: 100%;
  display: flex;
  gap: 4px;
  align-items: center;
  padding: 0 16px;
`;

export const StyledPreferencesTitle = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  ${setFontVariant('h5', colorsPalettes.carbon[500])};
`;

export const StyledPreferencesSubtitle = styled.div`
  position: relative;
  width: 100%;
  ${setFontVariant('caption', colorsPalettes.carbon[300])};
  padding: 4px 16px 10px;

  &::after {
    position: absolute;
    left: 0;
    bottom: 0px;
    display: block;
    content: '';
    width: 100%;
    border-bottom: 1px solid ${colorsPalettes.carbon[50]};
  }
`;

export const StyledClosePreferencesButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  padding: 8px;
  border: none;
  box-shadow: none;
  background-color: ${colorsPalettes.carbon[0]};
  transition: background-color 0.2s ease-in-out;
  cursor: pointer;

  &:hover {
    background-color: rgba(181, 190, 198, 0.2);
  }
`;
